export default {
  default: () => import("/Users/lion/Documents/work/outwork/website/nuxt3-template/layouts/default.vue").then(m => m.default || m)
}